import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PayCreditDebitComponent } from './pay-credit-debit/pay-credit-debit.component';
import { MakePaymentComponent } from './make-payment/make-payment.component';
import {SubmitPaymentComponent} from '../paymentus/make-payment/submit-payment.component';

const routes: Routes = [
   { path: 'make-payment', redirectTo: '/recharge', pathMatch: 'full' },
   { path: 'recharge', component: MakePaymentComponent},
   { path: 'make-payment/:amount', redirectTo: '/recharge/:amount', pathMatch: 'full' },
   { path: 'recharge/:amount', component: SubmitPaymentComponent},
   { path: 'make-payment/:amount/:new-card', redirectTo: '/recharge/:amount/:new-card', pathMatch: 'full' },
   { path: 'recharge/:amount/:new-card', component: PayCreditDebitComponent},
   { path: 'make-first-payment/:method', redirectTo: '/first-recharge/:method', pathMatch: 'full' },
   { path: 'first-recharge/:method', component: MakePaymentComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MakePaymentRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/payment/make-payment/make-payment-routing.module.ts